import { crashReporterInterface } from 'companion-app-components/utils/core';
import { bugsnagNotify } from 'utils/core/bugsnag';

// implement shared interfaces
crashReporterInterface.crashReporterInterfaceInit({
  reportError: bugsnagNotify,
});
